import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

/**
 * @param {Object} props
 * @param {echarts.EChartsOption} props.options - The echarts option
 * @param {React.CSSProperties} props.style
 * @param {number | string} props.chartWidth
 * @param {number | string} props.chartHeight
 * @param {MouseEventHandler<HTMLDivElement> | undefined} props.onClick
 * @returns {JSX.Element}
 */
export const PieChart = ({
  options,
  style,
  chartWidth,
  chartHeight,
  onClick,
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current, null, {
      width: chartWidth,
      height: chartHeight,
    });

    chartInstance.setOption(options);

    // const handleResize = () => chartInstance.resize();
    // window.addEventListener("resize", handleResize);

    return () => {
      // window.removeEventListener("resize", handleResize);
      chartInstance.dispose();
    };
  }, []);

  return <div ref={chartRef} style={style} onClick={onClick} />;
};

/**
 * Generates ECharts options to make a pie chart with custom color and 1 data like the Availability chart
 * @param {string} centerTitle
 * @param {string|null} centerSubtitle
 * @param {string} color
 * @param {number} data
 * @param {string} emptyColor
 * @returns
 */
export const generateCircularProgressBarOption = (
  centerTitle,
  centerSubtitle,
  color,
  data,
  emptyColor = "#d1d1d1"
) => {
  let text = `{a|${centerTitle}}`;
  if (centerSubtitle) {
    text += `\n{a|${centerSubtitle}}`;
  }

  return {
    legend: {
      show: false,
    },
    series: [
      {
        type: "pie",
        radius: ["60%", "80%"],
        avoidLabelOverlap: true,
        label: {
          show: true,
          position: "center",
          formatter: text,
          rich: {
            a: {
              fontSize: "0.6rem",
              fontWeight: "bold",
              color: "#333",
            },
          },
        },
        labelLine: {
          show: false,
        },
        data: [
          {
            value: data,
            itemStyle: { color },
          },
          {
            value: 100 - data,
            itemStyle: { color: emptyColor },
          },
        ],
      },
    ],
  };
};
